import { Grid, IconButton } from "@mui/material";
import { Close, Search } from "@mui/icons-material";
import { useEffect, useMemo, useState } from "react";

import Box from "../Box";
import Modal from "../Modal";
import Switch from "../Switch";
import Avatar from "../Avatar";
import CheckBox from "../CheckBox";
import FormField from "../FormField";
import Typography from "../Typography";
import Autocomplete from "../Autocomplete";
import Helpers from "../../commons/helpers";
import useStrings from "../../hooks/useStrings";
import Resources from "../../constants/resources";

import { LoadingInModal } from "../ModalSearchUser";
import { ICodename } from "../../commons/interfaces";
import { IRecordWorkingGroup } from "./cardUserGroup";
import { ActionRequest, GroupUserDefault, IsTrue, Mode } from "../../constants/enums";



const ModalCreateWorkingGroup = (props: {
    mode: number;
    visibleModal: boolean;
    newLableGroup?: string;
    newLableStaff?: string;

    dataGroupSelect: ICodename[];
    dataUserTitleSelect: ICodename[];
    isPermissionCheckGroupManager: boolean;
    dataRowsUserGroup: IRecordWorkingGroup[];

    onCloseModal: () => void;
    onActionModal: (items: IRecordWorkingGroup[]) => void;
}) => {
    const strings = useStrings();

    const [loadingModal, setLoadingModal] = useState<boolean>(false);
    const [modeModal, setModeModal] = useState<"main" | "detail">("main");

    const [loading, setLoading] = useState<boolean>(false);

    const [searchText, setSearchText] = useState<string>("");
    const [isSearchText, setIsSearchText] = useState<boolean>(false);
    const [dataRowsBySearchText, setDataRowsBySearchText] = useState<IRecordWorkingGroup[]>([]);

    const [dataRows, setDataRows] = useState<IRecordWorkingGroup[]>([]);
    const [dataSelect, setDataSelect] = useState<IRecordWorkingGroup[]>([]);

    useEffect(() => {

        if (props.visibleModal) {
            setLoading(true);

            const ids = [...props.dataRowsUserGroup || []]
                .filter((el) => (el.action !== ActionRequest.Delete))
                .map(el => el.groupId);

            const newRows = [...props.dataGroupSelect || []]
                .filter(el => (!ids.includes(el.code as string)))
                .map(el => ({
                    id: undefined,
                    userTitle: undefined,
                    manager: IsTrue.False,
                    default: GroupUserDefault.None,

                    groupName: el.name,
                    gene: el.detail?.gene,
                    groupId: el.code as string,
                    groupCode: el.detail?.groupCode,
                } as IRecordWorkingGroup));

            setDataRows(newRows);

            setLoading(false);
        };


        return () => {
            setSearchText("");
            setIsSearchText(false);
            setDataRowsBySearchText([]);

            setDataRows([]);
            setDataSelect([]);
        };
    }, [props.visibleModal, props.dataRowsUserGroup, props.dataGroupSelect]);

    const handleSearchText = (value: string) => {
        setLoading(true);

        setSearchText(value);

        setIsSearchText(true);

        const newRows: IRecordWorkingGroup[] = [];

        const newValue = Helpers.removeAccentsFromStrings(value).toLocaleLowerCase();
        dataRows.filter((item, key) => (
            Helpers.removeAccentsFromStrings(item.groupName || "").toLocaleLowerCase().includes(newValue) ||
            Helpers.removeAccentsFromStrings(item.groupCode || "").toLocaleLowerCase().includes(newValue)
        ));

        setDataRowsBySearchText(newRows);

        setLoading(false);
    };

    const handleSelectedById = (item: IRecordWorkingGroup) => {
        let newData = [...dataSelect || []];

        const indexTemp = newData?.findIndex(el => el.groupId === item.groupId);

        if (indexTemp === -1) {
            newData.push({ ...item });
        } else {
            newData.splice(indexTemp, 1);
        }

        setDataSelect(newData);
    };

    const newDataRows = useMemo(() => {
        if (isSearchText) {
            return dataRowsBySearchText;
        } else {
            return dataRows;
        }
    }, [isSearchText, dataRows, dataRowsBySearchText]);

    // Mode Detail
    const [itemWorkingGroup, setItemWorkingGroup] = useState<IRecordWorkingGroup | undefined>(undefined);

    const handleUpdateItemWorkingGroup = () => {
        let newData = [...dataSelect || []];

        const indexTemp = newData?.findIndex(el => el.groupId === itemWorkingGroup.groupId);

        if (indexTemp !== -1) {
            if (itemWorkingGroup?.default === GroupUserDefault.Default) {
                newData = newData.map(el => ({ ...el, default: GroupUserDefault.None }));
            } else {

            }

            newData[indexTemp] = { ...itemWorkingGroup };
        };

        setDataSelect(newData);

        setModeModal("main");

        setItemWorkingGroup(undefined);
    };

    return (
        <Modal
            fullWidth
            hasActionButton
            maxWidth={"sm"}
            visible={props.visibleModal}
            onClose={() => {
                if (modeModal === "main") {
                    props.onCloseModal();
                }
                if (modeModal === "detail") {
                    setModeModal("main");
                    setItemWorkingGroup(undefined);
                }
            }}
            onAction={() => {
                if (modeModal === "main") {
                    props.onActionModal(dataSelect);
                }
                if (modeModal === "detail") {
                    handleUpdateItemWorkingGroup();
                }
            }}
            title={modeModal === "detail" ? strings.Common.DETAIL : strings.Common.ADD_NEW}
        >
            <Box sx={{ height: "60vh" }}>
                {/*  */}
                {loadingModal &&
                    <LoadingInModal height="60vh" />
                }

                {!loadingModal &&
                    <>
                        {/* mode detail */}
                        {modeModal === "main" &&
                            <Box>
                                <Box>
                                    <FormField
                                        maxLength={255}
                                        variant="outlined"
                                        defaultValue={searchText || ""}
                                        placeholder={strings.format(strings.Group.SEARCH_TEXT, props.newLableGroup)}
                                        onBlur={(value: any) => {
                                            handleSearchText(value);
                                        }}
                                        onKeyPress={(e: any) => {
                                            if (e.key === "Enter") {
                                                handleSearchText(e?.target?.value);
                                            }
                                        }}
                                        InputProps={{
                                            startAdornment: (
                                                <IconButton
                                                    color="info"
                                                    onClick={() => {
                                                        handleSearchText(searchText);
                                                    }}
                                                >
                                                    <Search />
                                                </IconButton>
                                            ),
                                            endAdornment: searchText && (
                                                <IconButton
                                                    color="secondary"
                                                    onClick={() => {
                                                        setSearchText("");
                                                        setIsSearchText(false);
                                                        setDataRowsBySearchText([]);
                                                    }}
                                                >
                                                    <Close />
                                                </IconButton>
                                            ),
                                        }}
                                    />
                                </Box>
                                <Box sx={{
                                    marginTop: 2,
                                    height: "48vh",
                                    overflow: "auto",
                                }}>
                                    {loading
                                        ? (<LoadingInModal height="48vh" />)
                                        : ((newDataRows.length === 0)
                                            ? (
                                                <Box sx={{ textAlign: "center" }}>
                                                    <Typography variant="button" color="secondary">
                                                        {strings.Common.NO_DATA}
                                                    </Typography>
                                                </Box>
                                            )
                                            : (
                                                <Box>
                                                    <Box>
                                                        {
                                                            newDataRows.map((item, index) => {
                                                                const itemChecked = dataSelect?.find(el => el.groupId === item.groupId);

                                                                return (
                                                                    <Box
                                                                        key={"groupId_" + index}
                                                                        onClick={() => { handleSelectedById(item); }}
                                                                        sx={(theme) => {
                                                                            const { functions: { rgba }, palette: { info } } = theme;
                                                                            const isChoosed = dataSelect?.findIndex(el => el.groupId === item.groupId) !== -1;

                                                                            return {
                                                                                padding: "8px",
                                                                                display: "flex",
                                                                                flexWrap: "wrap",
                                                                                minHeight: "80px",
                                                                                borderRadius: "8px",
                                                                                marginBottom: "8px",
                                                                                alignItems: "center",
                                                                                border: `1px ${isChoosed ? info.main : "#c3c3c3"} solid`,
                                                                                backgroundColor: isChoosed ? rgba(info.main, 0.1) : "transparent",
                                                                                ":hover": {
                                                                                    cursor: "pointer",
                                                                                    border: `1px ${info.main} solid`,
                                                                                    backgroundColor: rgba(info.main, 0.1),
                                                                                }
                                                                            }
                                                                        }}
                                                                    >
                                                                        <CheckBox
                                                                            sx={{ width: "50px" }}
                                                                            checked={!Helpers.isNullOrEmpty(itemChecked?.groupId)}
                                                                        />

                                                                        <Box sx={{
                                                                            gap: 1,
                                                                            flexWrap: "wrap",
                                                                            alignItems: "center",
                                                                            width: "calc(100% - 50px)",
                                                                            justifyContent: "space-between",
                                                                            display: { xs: "grid", sm: "flex" },
                                                                        }}>
                                                                            <Box sx={{
                                                                                display: "flex",
                                                                                flexWrap: "wrap",
                                                                                alignItems: "center",
                                                                            }}>
                                                                                <Avatar
                                                                                    text={item?.groupName}
                                                                                    src={Resources.IMAGES.TEAM}
                                                                                    sx={{
                                                                                        marginLeft: "16px",
                                                                                        marginRight: "16px",
                                                                                        border: "1px #dddddd solid",
                                                                                        display: { xs: "none", sm: "flex" },
                                                                                    }}
                                                                                />
                                                                                <Box display="inline-grid">
                                                                                    <Typography variant="button" color="secondary" sx={{
                                                                                        overflow: "hidden",
                                                                                        whiteSpace: "nowrap",
                                                                                        textOverflow: "ellipsis",
                                                                                    }}>
                                                                                        {strings.Common.CODE}:&nbsp;{item?.groupCode}

                                                                                        {(itemChecked?.default === GroupUserDefault.Default) &&
                                                                                            <Typography
                                                                                                color="white"
                                                                                                variant="caption"
                                                                                                sx={{
                                                                                                    marginLeft: "8px",
                                                                                                    padding: "2px 6px",
                                                                                                    borderRadius: "4px",
                                                                                                    backgroundColor: "#1E97DE",
                                                                                                }}>
                                                                                                {Helpers.capitalizeFirstLetter(strings.format(strings.Staff.GROUP_DEFAULT, props.newLableGroup))}
                                                                                            </Typography>
                                                                                        }
                                                                                    </Typography>

                                                                                    <Typography variant="button" fontWeight="bold" sx={{
                                                                                        overflow: "hidden",
                                                                                        whiteSpace: "nowrap",
                                                                                        textOverflow: "ellipsis",
                                                                                    }}>
                                                                                        {item.groupName}
                                                                                    </Typography>

                                                                                </Box>
                                                                            </Box>
                                                                            {!Helpers.isNullOrEmpty(itemChecked?.groupId) &&
                                                                                <Box
                                                                                    sx={{ width: "60px" }}
                                                                                    onClick={(event) => {
                                                                                        event.stopPropagation();
                                                                                        setLoadingModal(true);

                                                                                        setTimeout(async (text?: string) => {
                                                                                            try {
                                                                                                setModeModal("detail");

                                                                                                setItemWorkingGroup(item);

                                                                                                setLoadingModal(false);
                                                                                            } catch (error) { } finally { }
                                                                                        }, 500);
                                                                                    }}
                                                                                >
                                                                                    <Typography variant="button" color="info"
                                                                                        sx={{
                                                                                            ":hover": {
                                                                                                cursor: "pointer",
                                                                                                fontWeight: "bold",
                                                                                                textDecoration: "underline",
                                                                                            }
                                                                                        }}
                                                                                    >
                                                                                        {strings.Common.DETAIL}
                                                                                    </Typography>
                                                                                </Box>
                                                                            }
                                                                        </Box>
                                                                    </Box>
                                                                )
                                                            })
                                                        }
                                                    </Box>
                                                </Box>
                                            )
                                        )
                                    }
                                </Box>
                            </Box>
                        }

                        {/* mode detail */}
                        {modeModal === "detail" &&
                            <Grid container spacing={3} padding={2}>
                                <Grid item xs={12} md={12}>
                                    <Box sx={{
                                        gap: 1,
                                        display: "flex",
                                        alignItems: "center",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        borderBottom: "1px solid #dddddd",
                                        paddingBottom: "12px",
                                    }}>
                                        <Avatar
                                            src={Resources.IMAGES.TEAM}
                                            text={itemWorkingGroup?.groupName}
                                            sx={{
                                                width: "5rem",
                                                height: "5rem",
                                                marginLeft: "16px",
                                                marginRight: "16px",
                                                border: "1px #dddddd solid",
                                            }}
                                        />
                                        <Box display="grid">
                                            <Typography variant="button">
                                                {strings.format(strings.Group.CODE_GROUP, props.newLableGroup)}:&nbsp;
                                                <Typography variant="button" fontWeight="bold">
                                                    {itemWorkingGroup?.groupCode}
                                                </Typography>
                                            </Typography>

                                            <Typography variant="button">
                                                {strings.format(strings.Group.NAME_GROUP, props.newLableGroup)}:&nbsp;
                                                <Typography variant="button" fontWeight="bold">
                                                    {itemWorkingGroup.groupName}
                                                </Typography>
                                            </Typography>

                                        </Box>
                                    </Box>
                                </Grid>

                                <Grid item xs={12} md={12}>
                                    <Box sx={{
                                        gap: 1,
                                        display: "flex",
                                        flexWrap: "wrap",
                                        alignItems: "center",
                                    }}>
                                        <Switch
                                            disabled={(props.mode === Mode.View)}
                                            checked={Number(itemWorkingGroup?.default) === GroupUserDefault.Default}
                                            onChange={(event, checked) => {
                                                const value = checked ? GroupUserDefault.Default : GroupUserDefault.None;
                                                setItemWorkingGroup(prev => ({
                                                    ...prev,
                                                    default: value,
                                                }));
                                            }}
                                        />
                                        <Typography variant="button" fontWeight={"bold"}>
                                            {Helpers.capitalizeFirstLetter(strings.format(strings.Staff.GROUP_DEFAULT, props.newLableGroup))}
                                        </Typography>
                                    </Box>
                                </Grid>

                                {
                                    props.isPermissionCheckGroupManager &&
                                    <Grid item xs={12} md={12}>
                                        <Box sx={{
                                            gap: 1,
                                            display: "flex",
                                            flexWrap: "wrap",
                                            alignItems: "center",
                                        }}>
                                            <Switch
                                                disabled={(props.mode === Mode.View)}
                                                checked={Number(itemWorkingGroup?.manager) === IsTrue.True}
                                                onChange={(event, checked) => {
                                                    let value = checked ? IsTrue.True : IsTrue.False;
                                                    setItemWorkingGroup(prev => ({
                                                        ...prev,
                                                        manager: value,
                                                    }));
                                                }}
                                            />
                                            <Typography variant="button" fontWeight={"bold"}>
                                                {Helpers.capitalizeFirstLetter(strings.format(strings.Staff.MANAGER_GROUP, props.newLableGroup))}
                                            </Typography>
                                        </Box>
                                    </Grid>
                                }

                                <Grid item xs={12} md={12}>
                                    <Autocomplete
                                        mode={props.mode}
                                        data={props.dataUserTitleSelect || []}
                                        defaultValue={itemWorkingGroup?.userTitle}
                                        label={Helpers.capitalizeFirstLetter(strings.format(strings.Staff.STAFF_POSITION, props.newLableStaff))}
                                        placeholder={Helpers.capitalizeFirstLetter(strings.format(strings.Staff.SELECT_STAFF_POSITION, props.newLableStaff))}
                                        onChange={(value) => {
                                            setItemWorkingGroup(prev => ({
                                                ...prev,
                                                userTitle: value,
                                            }))
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        }
                    </>
                }
            </Box>
        </Modal>
    );
};

export default ModalCreateWorkingGroup;